<div [ngClass]="getDeliveryClasses()">
  <ion-header class="delivery-header" [ngClass]="{'device': isDevicePlatform}">
    <pptl-unread-btn></pptl-unread-btn>

    <ion-row class="row-header">
      <ion-col class="list-indicator">&nbsp;</ion-col>
      <ion-col class="list-cover">&nbsp;</ion-col>
      <ion-col class="list-header list-rel">
        <span class="label">Received</span>
      </ion-col>
      <ion-col class="list-header list-delivery">
        <span class="label">Delivery</span>
      </ion-col>
      <div class="flex delivery favorite-btn"
        [ngClass]="{
        'reactivate-btn': isHistoryPage,
        'download-btn': isDevicePlatform
        }">
        <ion-col class="list-header list-artist">
          <span class="label">Artist</span>
        </ion-col>
        <ion-col class="list-header list-title">
          <span class="label">Title</span>
        </ion-col>
        <ion-col class="list-header list-label">
          <span class="label">Label</span>
        </ion-col>
      </div>
      <ion-col class="list-header list-type">
        <span class="label">Type</span>
      </ion-col>
      <ion-col class="list-header list-sent">
        <span class="label">Contacts</span>
      </ion-col>
      <ion-col class="list-buttons" [ngClass]="{'width-x2': isDevicePlatform}">&nbsp;</ion-col>
    </ion-row>
  </ion-header>

  <div class="delivery-container">
    <ion-content
      [scrollEvents]="true"
      class="delivery-content ion-page"
      #deliveryList
      [ngClass]="{'device': isDevicePlatform}">

      <div class="refresher-block">
        <ion-refresher slot="fixed" (ionRefresh)="ionRefresh($event)">
          <ion-refresher-content
            pullingIcon='null'
            refreshingSpinner="null"
            refreshingText="Refreshing...">
          </ion-refresher-content>
        </ion-refresher>
      </div>
      <div class="empty-result-block" *ngIf="!refreshing && !deliveries?.length && !isLoading">
        <span>No delivery found</span>
      </div>

      <div class="delivery-list" *ngIf="!refreshing">
        <ion-row  #deliveryListRows *ngFor="let delivery of deliveries; trackBy: trackByDeliveryKeyCode"
          class="list-row"
          [ngClass]="getRowClass(delivery)">
          <div class="hold-wrapper" (press)="holdHandler(delivery)" (click)="goToDelivery($event, delivery)"></div>
          <ion-col class="list-indicator">
            <span *ngIf="!delivery.openedDelivery" class="indicator"></span>
          </ion-col>

          <div class="flex release">
            <ion-col class="list-cover">
             <!--  <ion-spinner name="circles" class="spinner"></ion-spinner> -->
              <img [src]="getDeliveryImage(delivery)"
                (error)="imgLoadedErr(delivery)"
                @fade 
                alt=""
                class="list-image">
            </ion-col>

            <ion-col *ngIf="isDeliveryShowed" class="list-rel">
              {{convertDate(delivery?.deliveryDate)}}
            </ion-col>
          </div>

          <div class="flex delivery favorite-btn"
            [ngClass]="{
            'reactivate-btn': isHistoryPage,
            'download-btn': isDevicePlatform
            }">
            <ion-col class="list-artist">
              <div class="ellipsis" innerHTML="{{delivery?.artistName}}"></div>
            </ion-col>

            <ion-col class="list-title">
              <div class="ellipsis"
                innerHTML="{{delivery?.campaignName}}">
              </div>
              <ion-badge *ngIf="delivery?.countDown" class="badge">
                <span class="alarm-icon"></span>
                <span *ngIf="delivery?.countDown == 1; else spanDays"
                  class="badge-text">{{delivery?.countDown}} day</span>
                <ng-template #spanDays>
                  <span class="badge-text">{{delivery?.countDown}} days</span>
                </ng-template>
              </ion-badge>
            </ion-col>

            <ion-col class="list-label">
              <div class="ellipsis-always" innerHTML="{{delivery?.businessLabelName}}"></div>
            </ion-col>
          </div>

          <ion-col class="list-type">
            <div class="ellipsis-always" innerHTML="{{delivery?.deliveryType}}"></div>
          </ion-col>

          <ion-col class="list-sent">
            <div class="ellipsis-always" innerHTML="{{delivery?.contactName}}"></div>
          </ion-col>

          <ion-col class="list-buttons">
            <ion-buttons>
              <pptl-reactivate-btn *ngIf="isHistoryPage"
                [ngClass]="{'reactivated': delivery?.resendRequested}"
                [delivery]='delivery'>
              </pptl-reactivate-btn>
              <pptl-download-btn
                *ngIf="isDevicePlatform"
                [downloadConf]="downloadConf$|async"
                [delivery]='delivery'>
              </pptl-download-btn>
              <pptl-favorite-btn
                *ngIf="!isOffline"
                [delivery]='delivery'>
              </pptl-favorite-btn>
            </ion-buttons>
          </ion-col>
        </ion-row>
      </div>
      <div class="infinity-scroll" *ngIf="showInfinityScroll()">
        <ion-infinite-scroll threshold="100px" (ionInfinite)="onScroll($event)">
          <ion-infinite-scroll-content
            loadingSpinner="bubbles"
            loadingText="Loading more data...">
          </ion-infinite-scroll-content>
        </ion-infinite-scroll>
      </div>
    </ion-content>
  </div>
</div>
